import { styles } from "../styles";

// MyTime tile -- pie chart of the user's straight / OT / DT minutes for
// the current pay period, total hours below, click jumps to MyTimePage.
// Uses 7-day rolling for now; switches to org payPeriodConfig when the
// payroll-redesign work ships ([[project-payroll-redesign]]).

const fmtHours = (mins) => {
  if (!mins || mins <= 0) return "0:00";
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
};

// Slice from cumulative startAngle -> endAngle (radians, 0 = 12 o'clock,
// clockwise). Full-circle case returns a single arc path so a sole pay
// type still renders.
const slicePath = (cx, cy, r, startA, endA) => {
  if (endA - startA >= Math.PI * 2 - 0.0001) {
    return `M ${cx} ${cy - r} A ${r} ${r} 0 1 1 ${cx - 0.001} ${cy - r} Z`;
  }
  const x1 = cx + r * Math.sin(startA);
  const y1 = cy - r * Math.cos(startA);
  const x2 = cx + r * Math.sin(endA);
  const y2 = cy - r * Math.cos(endA);
  const largeArc = endA - startA > Math.PI ? 1 : 0;
  return `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
};

export default function MyTimeTile({ data, onClick }) {
  const {
    myTimeStraight = 0,
    myTimeOvertime = 0,
    myTimeDouble = 0,
  } = data;
  const total = myTimeStraight + myTimeOvertime + myTimeDouble;

  const cx = 30;
  const cy = 30;
  const r = 26;

  const slices = [
    { mins: myTimeStraight, color: "#1a7f37", label: "Straight" },
    { mins: myTimeOvertime, color: "#d97706", label: "OT" },
    { mins: myTimeDouble, color: "#c12c2c", label: "DT" },
  ].filter((s) => s.mins > 0);

  let acc = 0;
  const paths = slices.map((s) => {
    const startA = (acc / total) * 2 * Math.PI;
    acc += s.mins;
    const endA = (acc / total) * 2 * Math.PI;
    return { d: slicePath(cx, cy, r, startA, endA), color: s.color };
  });

  const hoverTitle =
    `Straight ${fmtHours(myTimeStraight)} · OT ${fmtHours(myTimeOvertime)} · DT ${fmtHours(myTimeDouble)}`;

  return (
    <div
      style={{
        ...styles.card,
        cursor: onClick ? "pointer" : "default",
        textAlign: "center",
      }}
      onClick={onClick}
      title={hoverTitle}
    >
      <strong>My Time</strong>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "6px 0",
        }}
      >
        {total > 0 ? (
          <svg width="60" height="60" viewBox="0 0 60 60">
            {paths.map((p, i) => (
              <path key={i} d={p.d} fill={p.color} />
            ))}
          </svg>
        ) : (
          <div
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "#eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "11px",
              color: "#888",
            }}
          >
            none
          </div>
        )}
      </div>
      <div style={{ fontSize: "20px", fontWeight: 600 }}>{fmtHours(total)}</div>
      <div style={{ fontSize: "11px", color: "#666" }}>This week</div>
    </div>
  );
}
